//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_TIPO_DOCUMENTOS = "obtenerTipoDocumentos";
export const OBTENER_TIPO_DOCUMENTOS_POR_SOCIO= "obtenerTipoDocumentosPorSocio";
export const OBTENER_TIPO_DOCUMENTO = "obtenerTipoDocumento";
export const REGISTRAR_DOCUMENTO = "registrarTipoDocumento";
export const ACTUALIZAR_TIPO_DOCUMENTO = "actualizarTipoDocumento";
// mutation types
export const SET_TIPO_DOCUMENTOS = "setTipoDocumentos";
export const SET_TIPO_DOCUMENTO = "setTipoDocumento";

const state = {
    tipoDocumentos: [],
    tipoDocumento:[],
}

const getters = {
    obtenerTipoDocumentos(state) {
      return state.archivos;
    },
}

const actions = {
    //Obtener Todos los tipos de docuemnto 
    async [OBTENER_TIPO_DOCUMENTOS](context) {

        return new Promise(resolve => {
            ApiService.query("apiconsume/obtener?endpoint=api/Empresas", '')
                .then(({ data }) => {
                    context.commit(SET_TIPO_DOCUMENTO, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    //Obtener tipos de documento por estado, por tipo socio y por sub tipo socio
    async [OBTENER_TIPO_DOCUMENTOS_POR_SOCIO](context, params) {

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=api/Tipo_Documentos/GetTipoDocumentoActivos/${params.estadoId}/${params.tipoSocioId}/${params.subTipoSocioId}`, '')
                .then(({ data }) => {
                    context.commit(SET_TIPO_DOCUMENTOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },


    

    async [OBTENER_TIPO_DOCUMENTO](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Empresas/`)
                .then(({ data }) => {
                    context.commit(SET_TIPO_DOCUMENTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },

    async [REGISTRAR_DOCUMENTO](context, archivo){
        console.log(archivo)
        //console.log(datosEmpresa)
        return new Promise(resolve => {
            ApiService.document(`apiconsume/document`, archivo)
                .then(({ data }) => {
                    context.commit(SET_TIPO_DOCUMENTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },
    
    async [ACTUALIZAR_TIPO_DOCUMENTO](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Empresas/UpdateEmpresas/`, datos.datosEmpresa)
                .then(({ data }) => {
                    context.commit(SET_TIPO_DOCUMENTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }

  }

const mutations = {
    [SET_TIPO_DOCUMENTOS](state, data) {
        state.tipoDocumentos = data;
    },

    [SET_TIPO_DOCUMENTO](state, data) {
        state.archivo = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}